export function Spinner() {
  return <span className="ui-spinner" role="status" aria-label="Loading" />;
}
